import { NavLink, Outlet, useLocation } from 'react-router-dom';
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarProvider,
  SidebarTrigger,
  useSidebar,
} from '@/components/ui/sidebar';
import { LayoutDashboard, ListOrdered, PlusCircle, KeyRound, Users } from 'lucide-react';

const items = [
  { title: 'Dashboard', url: '/reseller/dashboard', icon: LayoutDashboard },
  { title: 'Orders', url: '/reseller/orders', icon: ListOrdered },
  { title: 'New Order', url: '/reseller/orders/new', icon: PlusCircle },
  { title: 'Licenses', url: '/reseller/licenses', icon: KeyRound },
  { title: 'Customers', url: '/reseller/customers', icon: Users },
];

function ResellerSidebar() {
  const { state } = useSidebar();
  const collapsed = state === 'collapsed';
  const { pathname } = useLocation();
  return (
    <Sidebar collapsible="icon">
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel>Reseller</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {items.map((item) => (
                <SidebarMenuItem key={item.url}>
                  <SidebarMenuButton asChild isActive={pathname === item.url}>
                    <NavLink to={item.url} className="flex items-center gap-2">
                      <item.icon className="h-4 w-4" />
                      {!collapsed && <span>{item.title}</span>}
                    </NavLink>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
}

export default function ResellerLayout() {
  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full">
        <ResellerSidebar />
        <div className="flex-1 flex flex-col">
          <header className="h-12 flex items-center border-b px-2">
            <SidebarTrigger />
            <h1 className="ml-3 font-semibold">Reseller Portal</h1>
          </header>
          <main className="flex-1 p-6 bg-muted/20">
            <Outlet />
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
}
